/**
 * mobileRedirector decorator
 * 
 */
import React, { Component } from "react";
import cookie from 'react-cookies'
import CommonUtil from '../common/CommonUtil';
import isNil from 'lodash/isNil';
import get from 'lodash/get';
import { PLAYER_TYPE } from "../common/Foundation";

export default function mobileRedirector() {
  return function (Child) {
        return class extends Component {
     
            async componentDidMount() {
              const isRedirect = await this.needToRedirectToMobileVersion();
        	    if (isRedirect) {
                    let locale = CommonUtil.getCurrentLang();
                    const mobileView = window.env.mobileView || '/m/{locale}/asian';
            const sportName = get(this.props, 'match.params.sportName', '');
            const leagueName = get(this.props, 'match.params.leagueName', '');
            const leagueId = get(this.props, 'match.params.leagueId', '');
            const gameName = get(this.props, 'match.params.gameName', '');
            const specifySport = leagueName && leagueId && sportName ? sportName : cookie.load("specifySport");
            const pathName = specifySport ? (specifySport === "e-sports" && leagueId  ? `/esports` : `/sports/${specifySport}`) : "";
            const affiliateCode = CommonUtil.getParameterByName("a");
            const __udata = CommonUtil.getUserData() || {};
            if(CommonUtil.isIOSDevice() && affiliateCode && window.env.marketStrategies === PLAYER_TYPE.CASH){
              localStorage.setItem("afrc", affiliateCode);
            }
            const accountPage = get(this.props, 'match.params.accountPage', '');
            const containerName = get(this.props, 'pageContainer', '');
            const mobileViewPath = mobileView.replace('{locale}', CommonUtil.getCurrentLang());
            if (accountPage) {
              const transactionId = get(this.props, 'match.params.transactionId');
              const paymentChanelCode = get(this.props, 'match.params.paymentChanelCode', '');
              window.location = `${mobileViewPath}${this.addAccountTransactionPath(accountPage, paymentChanelCode, transactionId, __udata.auth)}`;
            } else if (containerName === 'activeLinkContainer') {
              const activeLinkPath = '/activeLink' + get(this.props, 'location.search', '');
              window.location = `${mobileViewPath}${activeLinkPath}`;
            } else {
              window.location = `${mobileViewPath}${this.addLeagueIdToMobilePath(pathName, leagueName, leagueId, gameName)}`;
            }
                }
            }
      addAccountTransactionPath = (accountPage, paymentChanelCode, transactionId, isAuth) => {
        return isAuth && accountPage && paymentChanelCode && transactionId ? `/account/${accountPage}/${paymentChanelCode}/${transactionId}` : '';
      }
      addLeagueIdToMobilePath = (pathName, leagueName, leagueId, gameName) => {
        return leagueId && leagueName ? (gameName ? `${pathName}/${gameName}/${leagueName}/${leagueId}` : `${pathName}/${leagueName}/${leagueId}`) : pathName;
      }

      needToRedirectToMobileVersion = async () => {
        const isMobileCookie = cookie.load('mobile');
        if (isNil(isMobileCookie) || isMobileCookie !== "false") {
          return await CommonUtil.isGalaxyZFold() || CommonUtil.isSmartPhone()
        }
        return false;
      }

            render() {
                return (
                    <Child {...this.props} />
                );
            }

        }
    }
}


// WEBPACK FOOTER //
// ./src/app/decorator/mobileRedirector.js